import { tenantService } from "../services/tenantService";
import { useAsyncData } from "./useAsyncData";

export function useTenants(search = "") {
  return useAsyncData(() => tenantService.listTenants(search), [search]);
}
